import { createContext, ReactNode, useCallback, useContext, useState } from 'react';

type ModalContextType = {
  openModal: (id: string) => void;
  closeModal: () => void;
  isOpenModal: (id: string) => boolean;
  openModalId: string | null;
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [openModalId, setOpenModalId] = useState<string | null>(null);

  const openModal = useCallback((id: string) => setOpenModalId(id), []);
  const closeModal = useCallback(() => setOpenModalId(null), []);
  const isOpenModal = useCallback((id: string) => openModalId === id, [openModalId]);

  return (
    <ModalContext.Provider value={{ openModal, closeModal, isOpenModal, openModalId }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModalContext must be used within ModalProvider');
  }
  return context;
};
